import {
  DISCOUNT_TYPE,
  RECEIPT_PAYMENT_MODE_ID,
  RECEIPT_PAYMENT_MODE_NAME,
} from "../enums/receipt";
import { DiscountType } from "../types/receipt";

export const paymentModeItems = [
  {
    label: RECEIPT_PAYMENT_MODE_NAME.CASH,
    value: RECEIPT_PAYMENT_MODE_ID.CASH,
    key: RECEIPT_PAYMENT_MODE_ID.CASH,
  },
  {
    label: RECEIPT_PAYMENT_MODE_NAME.CREDIT_CARD,
    value: RECEIPT_PAYMENT_MODE_ID.CREDIT_CARD,
    key: RECEIPT_PAYMENT_MODE_ID.CREDIT_CARD,
  },
  {
    label: RECEIPT_PAYMENT_MODE_NAME.DEBIT_CARD,
    value: RECEIPT_PAYMENT_MODE_ID.DEBIT_CARD,
    key: RECEIPT_PAYMENT_MODE_ID.DEBIT_CARD,
  },
  {
    label: RECEIPT_PAYMENT_MODE_NAME.PAYTM,
    value: RECEIPT_PAYMENT_MODE_ID.PAYTM,
    key: RECEIPT_PAYMENT_MODE_ID.PAYTM,
  },
  {
    label: RECEIPT_PAYMENT_MODE_NAME.GPAY,
    value: RECEIPT_PAYMENT_MODE_ID.GPAY,
    key: RECEIPT_PAYMENT_MODE_ID.GPAY,
  },
  {
    label: RECEIPT_PAYMENT_MODE_NAME.UPI,
    value: RECEIPT_PAYMENT_MODE_ID.UPI,
    key: RECEIPT_PAYMENT_MODE_ID.UPI,
  },
  {
    label: RECEIPT_PAYMENT_MODE_NAME.OTHER,
    value: RECEIPT_PAYMENT_MODE_ID.OTHER,
    key: RECEIPT_PAYMENT_MODE_ID.OTHER,
  },
];

export const DISCOUNT_TYPE_CALC: {
  [k in DISCOUNT_TYPE]: (price: number, discount: number, qt: number) => number;
} = {
  AMOUNT: (price: number, discount: number, qt: number) =>
    price * (qt || 0) - discount,
  PERCENTAGE: (price: number, discount: number, qt: number) =>
    (price - (discount / 100) * price) * (qt || 0),
};

export const PAY_MODES: Array<{
  isActive: boolean;
  id: RECEIPT_PAYMENT_MODE_ID;
  name: string;
}> = [
  {
    id: RECEIPT_PAYMENT_MODE_ID.CASH,
    name: RECEIPT_PAYMENT_MODE_NAME.CASH,
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.CREDIT_CARD,
    name: RECEIPT_PAYMENT_MODE_NAME.CREDIT_CARD,
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.DEBIT_CARD,
    name: RECEIPT_PAYMENT_MODE_NAME.DEBIT_CARD,
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.PAYTM,
    name: RECEIPT_PAYMENT_MODE_NAME.PAYTM,
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.GPAY,
    name: RECEIPT_PAYMENT_MODE_NAME.GPAY,
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.UPI,
    name: RECEIPT_PAYMENT_MODE_NAME.UPI,
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.OTHER,
    name: RECEIPT_PAYMENT_MODE_NAME.OTHER,
    isActive: true,
  },
];

export const RECEIPT_DISCOUNT_TYPES: DiscountType[] = [
  {
    id: DISCOUNT_TYPE.AMOUNT,
    name: "₹",
  },
  {
    id: DISCOUNT_TYPE.PERCENTAGE,
    name: "%",
  },
];
